import { ModalWidth, formatDisplayFullDate } from '@/config';
import { Button, Modal, Tooltip } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoOutlined } from '@ant-design/icons';
import ZTable, { IColumnType, IFilterItem } from '@/components/ZTable';
import { PaymentModeType } from '@/constants';
import { formatCurrency } from '@/helpers/format';
import { RegisterBookingPaymentModel } from '@/__generated';

type Props = {
  registerId: string;
  onClose: () => void;
};
const columns: IColumnType<RegisterBookingPaymentModel>[] = [
  {
    title: 'registerPage_PayMode',
    dataIndex: 'payMode',
    ellipsis: true,
    render: v => PaymentModeType.__getValue(v),
    width: 120,
    sorter: true,
  },
  {
    title: 'base.Date',
    dataIndex: 'createdOn',
    ellipsis: true,
    width: 170,
    render: v => formatDisplayFullDate(v),
    sorter: true,
  },

  {
    title: 'base.Amount',
    dataIndex: 'totalAmount',
    width: 120,
    render: v => <b>{formatCurrency(v)}</b>,
    sorter: true,
  },
  {
    title: 'ticketBooking_BookingRefNo',
    dataIndex: 'bookingRefNo',
    ellipsis: true,
    width: 160,
  },
  {
    title: 'ticketBooking_TicketRefNo',
    dataIndex: 'receiptRefNo',
    ellipsis: true,
  },
  {
    title: 'base.Note',
    dataIndex: 'transactionMessage',
    width: 80,
    render: v =>
      v ? (
        <Tooltip title={v}>
          <Button size="small" type="link" icon={<InfoOutlined />} />
        </Tooltip>
      ) : (
        ''
      ),
  },
  {
    title: 'registerPage_CashierName',
    dataIndex: 'createdBy',
    ellipsis: true,
  },
];
const filters: Array<IFilterItem> = [
  { type: 'TEXT', name: 'bookingRefNo', label: 'ticketBooking_BookingRefNo' },
  { type: 'TEXT', name: 'receiptRefNo', label: 'ticketBooking_TicketRefNo' },
];
export default function TicketPaymentRecordModal({ registerId, onClose }: Props) {
  const { t } = useTranslation();
  return (
    <Modal
      style={{ top: 10 }}
      open={true}
      maskClosable={false}
      width={ModalWidth.extraLarge}
      className="nta-custom-form"
      title={t('registerPage_TicketPayments')}
      forceRender={true}
      okText={t('Close')}
      okButtonProps={{ className: 'save-btn' }}
      cancelButtonProps={{ style: { display: 'none' } }}
      onOk={onClose}
      onCancel={onClose}
    >
      <ZTable<RegisterBookingPaymentModel>
        columns={columns}
        primaryKey="id"
        url="/bookings/payment-details/get-register-payment-records"
        bordered
        defaultFilter={{ registerId: registerId }}
        order_by="createdOn"
        order_by_asc={true}
        allowEdit={false}
        allowDelete={false}
        filters={filters}
        searchBtnAlignLeft
      ></ZTable>
    </Modal>
  );
}
